
import { Vue } from "vue-class-component";
export default class MoreLoading extends Vue {}
